module.exports = __webpack_public_path__ + "img/04.025421c0.png";